import React, { useState } from 'react';

const AddGradeModal = () => {
  const [gradeData, setGradeData] = useState({
    assessmentType: '',
    subject: '',
    class: '',
    title: '',
    totalMarks: 100,
    date: new Date().toISOString().split('T')[0],
    description: '',
    gradeEntryMode: 'individual'
  });

  // Mock student data
  const [studentGrades, setStudentGrades] = useState([
    { id: '1', name: 'John Smith', rollNo: '001', marksObtained: '', grade: '', remarks: '' },
    { id: '2', name: 'Sarah Johnson', rollNo: '002', marksObtained: '', grade: '', remarks: '' },
    { id: '3', name: 'Mike Wilson', rollNo: '003', marksObtained: '', grade: '', remarks: '' },
    { id: '4', name: 'Emily Davis', rollNo: '004', marksObtained: '', grade: '', remarks: '' }
  ]);

  const assessmentTypes = [
    'Quiz',
    'Test',
    'Mid-term Exam',
    'Final Exam',
    'Assignment',
    'Project',
    'Presentation',
    'Lab Work',
    'Class Participation'
  ];

  const calculateGrade = (marks: number, total: number) => {
    const percentage = (marks / total) * 100;
    if (percentage >= 90) return 'A+';
    if (percentage >= 80) return 'A';
    if (percentage >= 70) return 'B+';
    if (percentage >= 60) return 'B';
    if (percentage >= 50) return 'C';
    if (percentage >= 40) return 'D';
    return 'F';
  };

  const handleStudentGradeChange = (studentId: string, field: string, value: string) => {
    setStudentGrades(studentGrades.map(student => {
      if (student.id === studentId) {
        const updatedStudent = { ...student, [field]: value };
        
        // Auto-calculate grade when marks are entered
        if (field === 'marksObtained' && value && !isNaN(Number(value))) {
          updatedStudent.grade = calculateGrade(Number(value), gradeData.totalMarks);
        }
        
        return updatedStudent;
      }
      return student;
    }));
  };

  const handleSubmit = () => {
    // TODO: Submit grades API call
    console.log('Submitting grades:', {
      ...gradeData,
      grades: studentGrades.filter(s => s.marksObtained !== '')
    });
  };

  const getGradeStats = () => {
    const gradedStudents = studentGrades.filter(s => s.marksObtained !== '');
    const total = gradedStudents.length;
    const avgMarks = total > 0 ? 
      gradedStudents.reduce((sum, s) => sum + Number(s.marksObtained), 0) / total : 0;
    return { total, avgMarks: avgMarks.toFixed(1) };
  };

  const stats = getGradeStats();

  return (
    <div className="modal fade" id="addGradeModal">
      <div className="modal-dialog modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Add Grades</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div className="modal-body">
            <form>
              {/* Assessment Details */}
              <div className="row mb-4">
                <div className="col-md-3 mb-3">
                  <label className="form-label">Assessment Type <span className="text-danger">*</span></label>
                  <select 
                    className="form-select"
                    value={gradeData.assessmentType}
                    onChange={(e) => setGradeData({...gradeData, assessmentType: e.target.value})}
                    required
                  >
                    <option value="">Select Type</option>
                    {assessmentTypes.map((type) => (
                      <option key={type} value={type}>{type}</option>
                    ))}
                  </select>
                </div>
                <div className="col-md-3 mb-3">
                  <label className="form-label">Subject <span className="text-danger">*</span></label>
                  <select 
                    className="form-select"
                    value={gradeData.subject}
                    onChange={(e) => setGradeData({...gradeData, subject: e.target.value})}
                    required
                  >
                    <option value="">Select Subject</option>
                    <option value="mathematics">Mathematics</option>
                    <option value="english">English</option>
                    <option value="science">Science</option>
                    <option value="history">History</option>
                    <option value="geography">Geography</option>
                  </select>
                </div>
                <div className="col-md-3 mb-3">
                  <label className="form-label">Class <span className="text-danger">*</span></label>
                  <select 
                    className="form-select"
                    value={gradeData.class}
                    onChange={(e) => setGradeData({...gradeData, class: e.target.value})}
                    required
                  >
                    <option value="">Select Class</option>
                    <option value="grade-9">Grade 9</option>
                    <option value="grade-10">Grade 10</option>
                    <option value="grade-11">Grade 11</option>
                    <option value="grade-12">Grade 12</option>
                  </select>
                </div>
                <div className="col-md-3 mb-3">
                  <label className="form-label">Date</label>
                  <input 
                    type="date" 
                    className="form-control"
                    value={gradeData.date}
                    onChange={(e) => setGradeData({...gradeData, date: e.target.value})}
                  />
                </div>
              </div>

              <div className="row mb-4">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Title <span className="text-danger">*</span></label>
                  <input 
                    type="text" 
                    className="form-control"
                    value={gradeData.title}
                    onChange={(e) => setGradeData({...gradeData, title: e.target.value})}
                    placeholder="e.g., Chapter 5 Quiz, Mid-term Exam"
                    required
                  />
                </div>
                <div className="col-md-3 mb-3">
                  <label className="form-label">Total Marks</label>
                  <input 
                    type="number" 
                    className="form-control"
                    value={gradeData.totalMarks}
                    onChange={(e) => setGradeData({...gradeData, totalMarks: Number(e.target.value)})}
                    min="1"
                    max="1000"
                  />
                </div>
                <div className="col-md-3 mb-3">
                  <label className="form-label">Graded Students</label>
                  <div className="form-control-static">
                    <strong>{stats.total}</strong> of {studentGrades.length} students
                  </div>
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label">Description</label>
                <textarea 
                  className="form-control"
                  rows={2}
                  value={gradeData.description}
                  onChange={(e) => setGradeData({...gradeData, description: e.target.value})}
                  placeholder="Additional notes about this assessment..."
                />
              </div>

              {/* Stats */}
              {stats.total > 0 && (
                <div className="alert alert-info mb-3">
                  <div className="row">
                    <div className="col-md-3">
                      <strong>Graded:</strong> {stats.total}/{studentGrades.length}
                    </div>
                    <div className="col-md-3">
                      <strong>Average:</strong> {stats.avgMarks}/{gradeData.totalMarks}
                    </div>
                    <div className="col-md-3">
                      <strong>Percentage:</strong> {((Number(stats.avgMarks) / gradeData.totalMarks) * 100).toFixed(1)}%
                    </div>
                  </div>
                </div>
              )}

              {/* Student Grades */}
              <div className="table-responsive">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>Roll No</th>
                      <th>Student Name</th>
                      <th>Marks Obtained</th>
                      <th>Grade</th>
                      <th>Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    {studentGrades.map((student) => (
                      <tr key={student.id}>
                        <td>{student.rollNo}</td>
                        <td>
                          <div className="d-flex align-items-center">
                            <div className="avatar avatar-sm me-2">
                              <span className="avatar-title bg-primary-transparent text-primary">
                                {student.name.charAt(0)}
                              </span>
                            </div>
                            {student.name}
                          </div>
                        </td>
                        <td>
                          <div className="input-group input-group-sm" style={{width: '120px'}}>
                            <input 
                              type="number"
                              className="form-control"
                              value={student.marksObtained}
                              onChange={(e) => handleStudentGradeChange(student.id, 'marksObtained', e.target.value)}
                              min="0"
                              max={gradeData.totalMarks}
                              placeholder="0"
                            />
                            <span className="input-group-text">/{gradeData.totalMarks}</span>
                          </div>
                        </td>
                        <td>
                          <span className={`badge ${
                            student.grade === 'A+' || student.grade === 'A' ? 'badge-soft-success' :
                            student.grade === 'B+' || student.grade === 'B' ? 'badge-soft-primary' :
                            student.grade === 'C' ? 'badge-soft-warning' :
                            student.grade === 'D' || student.grade === 'F' ? 'badge-soft-danger' :
                            'badge-soft-secondary'
                          }`}>
                            {student.grade || '-'}
                          </span>
                        </td>
                        <td>
                          <input 
                            type="text"
                            className="form-control form-control-sm"
                            value={student.remarks}
                            onChange={(e) => handleStudentGradeChange(student.id, 'remarks', e.target.value)}
                            placeholder="Optional remarks"
                            style={{width: '150px'}}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </form>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-cancel" data-bs-dismiss="modal">
              Cancel
            </button>
            <button 
              type="button" 
              className="btn btn-primary" 
              onClick={handleSubmit}
              disabled={!gradeData.assessmentType || !gradeData.subject || !gradeData.title || stats.total === 0}
            >
              <i className="ti ti-device-floppy me-2"></i>Save Grades
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddGradeModal;
